/* eslint-disable max-len */

import { defineMessages } from 'react-intl'

export default defineMessages({
  cookieConsentText: 'Please accept marketing cookies to watch our YouTube videos.',
  cookieConsentButton: 'Cookie settings'
})
